"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { apiPost, startGoogleAuth } from "../components/api";

export default function LoginPage() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    setError(null);
    setLoading(true);
    try {
      const data = await apiPost<{ token: string; refreshToken?: string }>(
        "/v1/auth/login",
        {
        email,
        password
        }
      );
      localStorage.setItem("auth_token", data.token);
      if (data.refreshToken) {
        localStorage.setItem("refresh_token", data.refreshToken);
      }
      router.push("/dashboard");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <nav className="nav">
        <div className="brand">AudioHawk</div>
        <div className="links">
          <Link href="/">Home</Link>
          <Link href="/register">Register</Link>
        </div>
      </nav>

      <main className="hero">
        <div>
          <div className="section-title">Sign In</div>
          <h1>Welcome back.</h1>
          <p>Authenticate with Google or email to access the control plane.</p>
        </div>

        <div className="card">
          <h2>Login</h2>
          <form
            className="form"
            onSubmit={(event) => {
              event.preventDefault();
              void onSubmit();
            }}
          >
            <div>
              <label>Email</label>
              <input
                type="email"
                placeholder="name@audiohawk.io"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </div>
            <div>
              <label>Password</label>
              <input
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </div>
            {error ? <div style={{ color: "var(--muted)" }}>{error}</div> : null}
            <button className="button" type="submit" disabled={loading}>
              {loading ? "Signing In..." : "Sign In"}
            </button>
            <button
              className="button secondary"
              type="button"
              onClick={startGoogleAuth}
            >
              Continue with Google
            </button>
            <Link href="/reset" className="section-title">
              Forgot password?
            </Link>
          </form>
        </div>
      </main>
    </div>
  );
}
